export const EXTENSION_CONFIG = {
	PRIMARY_ID: 'ihcgicdogclbieclnldfjmlglkolankb', //'ihcgicdogclbieclnldfjmlglkolankb', // 'hcblpdfoicfooebikfpndclnjiikiogm'

	EXTENSION_NAME: 'LoadFetcher Extension',

	STORE_URL:
		'https://chrome.google.com/webstore/detail/ihcgicdogclbieclnldfjmlglkolankb',

	TIMEOUTS: {
		PING: 5000, // 5 seconds for ping check
		DEFAULT: 5000, // 5 seconds default
		POST_TRUCK: 45000, // a stale Relay tab is retried in a freshly opened tab
	},
}

export default EXTENSION_CONFIG
